(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casecase-ai-upload-entry"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cc-upload-photo-guide')) {
    customElements.define('cc-upload-photo-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.dialog = this.querySelector('.ccai-pg__dialog');
        if (!this.dialog) return;
        const options = { signal: this.events.signal };
        this.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-ccai-pg-open]');
          if (trigger && this.contains(trigger)) {
            event.preventDefault();
            this.openExample(trigger);
          }
          if (event.target.closest('[data-ccai-pg-close]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.querySelector('.ccai-pg__large-image-wrap').replaceChildren();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
      }
      openExample(trigger) {
        if (typeof this.dialog.showModal !== 'function') return;
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const source = mobile ? trigger.dataset.mobileImage : trigger.dataset.fullImage;
        if (!source) return;
        const image = document.createElement('div');
        image.className = 'ccai-pg__large-image';
        image.setAttribute('role', 'img');
        image.setAttribute('aria-label', trigger.dataset.caption || '');
        image.style.backgroundImage = `url(${JSON.stringify(source)})`;
        this.querySelector('.ccai-pg__large-image-wrap').replaceChildren(image);
        this.querySelector('.ccai-pg__dialog-title').textContent = trigger.dataset.caption || '';
        this.opener = trigger;
        if (!this.dialog.open) this.dialog.showModal();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        if (this.dialog?.open) this.dialog.close();
        this.opener = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
